export default __webpack_public_path__ + "static/media/undraw_projections_re_ulc6.9fa8e587.png";